import Vue from 'vue'
import { lang } from '@/js/lang'

Vue.filter('lang', (slug) => {
	return lang(slug)
})
